"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNING_ENTITY_TYPES = void 0;
/** Who can sign a legal document. The single list both the type and runtime parsers (e.g. zod schemas) derive from. */
exports.SIGNING_ENTITY_TYPES = ['applicant', 'advisorLead', 'thirdPartyLead', 'mlo', 'udp', 'depositProduct', 'partnerUser'];
